import React, { useState } from 'react';
import api from '../../../service/api';
import ReactLoading from 'react-loading';
import { cpfCnpjMask } from '../../mask/cpfCnpjMask';
import { isValidCNPJ, isValidCPF } from '../../../validators/validators.js';

function Home() {
  const [exibirLoading, setExibirLoading] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('Nenhum documento encontrado!');
  const [cpfCnpj, setCpfCnpj] = useState('')

  const inputChange = (e) => {
    setCpfCnpj(e.target.value)
  }


  async function getDocuments() {
    //console.clear()

    const cpfCnpj = document.getElementById('cpf-cnpj').value;
    console.log(cpfCnpj)

//    if (cpfCnpj.length === '') {
//      setMessage('Preencha o CPF/CNPJ!');
//      return;
//    }

    // Verifica se é CPF ou CNPJ
    if (cpfCnpj.length <= 14) {
      // CPF      
      console.log('Validando CPF!');
      if (!isValidCPF(cpfCnpj)) {
        setMessage('CPF inválido!');
        return;
      }
    } else {
      // CNPJ
      console.log('Validando CNPJ!');
      if (!isValidCNPJ(cpfCnpj)) {
        console.log('CNPJ inválido!');
        setMessage('CNPJ inválido!');
        return;
      }
    }


    if (cpfCnpj !== '') {
      setLoading(true);
      setExibirLoading(true)
      await api.get(`/api/gerente/v2/getsituacaofinanceiracliente?cnpj=${cpfCnpj}`)
        .then(resp => {
          setExibirLoading(false)
          setLoading(false); 
          if (!(JSON.stringify(resp.data)==='[]')){
            setRegistros(resp.data);
          }
          else
          {
            setMessage('Nenhum documento encontrado!');
          }
        })
        .catch(error => {
          console.log(error);
          setMessage('Erro ao buscar as informações financeiras do cliente!');
          setExibirLoading(false)
          setLoading(false);
        });
    } else {
      setMessage('Preencha o CPF/CNPJ!');
    }
  }

  const currencyFormat = (num) => {
    return 'R$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(',', '!').replace('.', ',').replace('!', '.')
  }

  const visualizar = (id) => {
    console.log(id)
    window.open(`http://criaresuporte1.no-ip.info:8080/CriareWeb/imprimeboleto.aspx?id=${id}`)
  }


  return (


    <div className="container page">
      <div className="container col-sm-4 dados rounded">
        <p />
        <div className="row" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          marginBottom: '8px',
        }}>
            <p>Informe o CPF ou CNPJ</p>
          <div className="col-sm-10">
            <input type="text" className="form-control" id="cpf-cnpj" name="cpf-cnpj" value={cpfCnpjMask(cpfCnpj)} onChange={inputChange} placeholder="CPF/CNPJ" />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" align="right">
            <button className="form-control btn btn-primary " onClick={() => getDocuments()}>Buscar</button>
          </div>
        </div>
        <p />

      </div>
      {
        (exibirLoading && loading) ?
          <>
            <div className="container loader_container">
              <ReactLoading type="bars" color="#282c34" height={'30px'} width={'50px'} />
            </div>
          </>
          : ''
      }
      <p />
      <hr />
      <div className="container">
        {registros.length > 0 ?
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th scope="col">Título</th>
                  <th scope="col">Data</th>
                  <th scope="col">Valor</th>
                  <th scope="col">Vencimento</th>
                  <th scope="col">Competência</th>
                  <th scope="col">Histórico</th>
                  <th scope="col">Ações</th>
                </tr>
              </thead>
              <tbody>
                {registros.map(document => (


                  <tr>
                    <th scope="row">{document.titulo}</th>
                    <td>{document.data}</td>
                    <td data-field="price" data-formatter="priceFormatter">{currencyFormat(document.valor)}</td>
                    <td>{document.vencimento}</td>
                    <td>{document.competencia}</td>
                    <td>{document.historico}</td>
                    <td>
                      <button className="btn btn-primary" onClick={() => visualizar(document.idCreceber)}>Imprimir Boleto</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          :
          <div className="alert alert-info">
            <strong>{message}</strong>
          </div>}

      </div>


    </div>


  );

}

export default Home;
